import React from 'react';
import { SkText } from '../../components/SkeletonLoader/SkeletonLoader';
import styles from '../clients/ClientesPageSkeleton.module.css';

const COL_WIDTHS = [80, 50, 70, 70, 180, 120, 80, 100, 80, 80, 80, 60];

const TableRowSk: React.FC = () => (
  <div className={styles.row}>
    {COL_WIDTHS.map((w, i) => (
      <SkText key={i} width={w} height={13} style={{ flexShrink: 0 }} />
    ))}
  </div>
);

const PedidosPageSkeleton: React.FC = () => (
  <div className={styles.skeletonWrapper}>
    <div className={styles.tableCard}>
      {/* 12 rows */}
      {Array.from({ length: 15 }).map((_, i) => <TableRowSk key={i} />)}
    </div>
  </div>
);

export default PedidosPageSkeleton;
